const isStorageSupported = (storageType = 'localStorage') => {
  if (typeof window === 'undefined') return false;

  try {
    const storage = window[storageType];
    const testKey = '__3toolspro_storage_test__';
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
};

export const safeStorage = {
  get(key, fallback = null, storageType = 'localStorage') {
    if (!isStorageSupported(storageType)) return fallback;

    try {
      const value = window[storageType].getItem(key);
      return value ?? fallback;
    } catch {
      return fallback;
    }
  },
  set(key, value, storageType = 'localStorage') {
    if (!isStorageSupported(storageType)) return false;

    try {
      window[storageType].setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },
  remove(key, storageType = 'localStorage') {
    if (!isStorageSupported(storageType)) return false;

    try {
      window[storageType].removeItem(key);
      return true;
    } catch {
      return false;
    }
  },
};

export const safeJsonParse = (rawValue, fallback = null) => {
  if (!rawValue || typeof rawValue !== 'string') return fallback;

  try {
    return JSON.parse(rawValue);
  } catch {
    return fallback;
  }
};
